import {useContext, useEffect} from "react";
import AuthContext from "../contexts/AuthContext";
import Sonnerie from '../assets/audio/sonnerie_v2.mp3';
import {useStoreExecutions} from "../store/useStoreExecutions";
import {useEventProvider} from "../providers/EventProvider.tsx";

export function useNotifications() {
    const {user} = useContext(AuthContext);
    const setExecutionsInProgress = useStoreExecutions((state) => state.setExecutionsInProgress);
    const executionsInPendingCount = useStoreExecutions((state) => state.executionsInPendingCount);
    const {newExecutions} = useEventProvider();

    useEffect(() => {
        if (newExecutions.data && executionsInPendingCount !== newExecutions.data.count) {
            setExecutionsInProgress(newExecutions.data.count, user);
            handlePlay();
        }
    }, [newExecutions]);

    // Gestion du lancement de la sonnerie
    function handlePlay() {
        const iframeRing = document.createElement('iframe');
        iframeRing.id = 'background-audio';
        iframeRing.src = Sonnerie;
        iframeRing.allow = 'autoplay';
        iframeRing.classList.add('d-none');
        document.body.appendChild(iframeRing);
        setInterval(() => {
            iframeRing.remove();
        }, 4000);
    }

    return {handlePlay};
}